export const HomePath = "/mobile-shop";